import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "content-wrapper" };
import { RouterView } from "vue-router";
export default /*#__PURE__*/ _defineComponent({
    __name: 'Page',
    props: {
        displayType: {}
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_unref(RouterView), null, {
                    default: _withCtx(({ Component }) => [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(Component), { displayType: _ctx.displayType }, null, 8 /* PROPS */, ["displayType"]))
                    ]),
                    _: 1 /* STABLE */
                })
            ]));
        };
    }
});
